const validateEmail = (email:string) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

const validateUrl = (url:string) => {
    return url.match(
        /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
    );
};

const validateLinkedinUrl = (url:string) => {
    let matchesUrl = url.match(
        /^(http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/
    );
    let matchesLinkedIn = url.includes('linkedin');
    return matchesUrl && matchesLinkedIn;
};

const validatePhone = (phone:string, required: boolean = true, label:string) => {
    if ((required || phone.length > 0) && !phone.startsWith('+')) {
        return label + ' muss mit dem Ländercode z.B. +49 beginnen';
    }
    if (/[^0-9+-/ ]/.exec(phone) !== null) {
        return label + ' darf nur Zahlen, Leerzeichen und +-/ enthalten';
    }
    let strippedPhone = phone.replace(/[^0-9]/g, '');
    if (strippedPhone.length > 0 && strippedPhone.length < 8) {
        return label + ' ist zu kurz';
    }
    if (strippedPhone.length > 15) {
        return label + ' ist zu lang';
    }
    return true;
};

const validateIban = (iban:string) => {
    if (iban.length < 5) {
        return false;
    }
    
    iban = iban.toLowerCase().replace(/\s/g, '');
    const countries = {
        al: 28, ad: 24, at: 20, az: 28, bh: 22, be: 16, ba: 20, br: 29, bg: 22, cr: 21, hr: 21, cy: 28, cz: 24, dk: 18, 
        do: 28, ee: 20, fo: 18, fi: 18, fr: 27, ge: 22, de: 22, gi: 23, gr: 27, gl: 18, gt: 28, hu: 28, is: 26, ie: 22, 
        il: 23, it: 27, jo: 30, kz: 20, kw: 30, lv: 21, lb: 28, li: 21, lt: 20, lu: 20, mk: 19, mt: 31, mr: 27, mu: 30, 
        mc: 27, md: 24, me: 22, nl: 18, no: 15, pk: 24, ps: 29, pl: 28, pt: 25, qa: 29, ro: 24, sm: 27, sa: 24, rs: 22, 
        sk: 24, si: 19, es: 24, se: 24, ch: 21, tn: 24, tr: 26, ae: 23, gb: 22, vg: 24
    };
    const chars = {
        a: 10, b: 11, c: 12, d: 13, e: 14, f: 15, g: 16, h: 17, i: 18, j: 19, k: 20, l: 21, m: 22, n: 23, o: 24, p: 25, 
        q: 26, r: 27, s: 28, t: 29, u: 30, v: 31, w: 32, x: 33, y: 34, z: 35
    };

    const countryCode = iban.substring(0, 2);
    if (countries.hasOwnProperty(countryCode) && iban.length === countries[countryCode]) {
        let movedChar = iban.substring(4) + iban.substring(0, 4);
        let newString = '';
        
        for (let char of movedChar) {
            newString += isNaN(char) ? chars[char] || '' : char;
        }
        
        return BigInt(newString) % 97n === 1n;
    }
    return false;
};

const validateBic = (bic:string, iban: string = '') => {
    const countryCode = iban.toLowerCase().replace(/\s/g, '').substring(0, 2);
    if (countryCode !== 'de') {
        const bicRegex = /^[A-Z0-9]{4}(?:AD|AE|AF|AG|AI|AL|AM|AO|AQ|AR|AS|AT|AU|AW|AX|AZ|BA|BB|BD|BE|BF|BG|BH|BI|BJ|BL|BM|BN|BO|BQ|BR|BS|BT|BV|BW|BY|BZ|CA|CC|CD|CF|CG|CH|CI|CK|CL|CM|CN|CO|CR|CU|CV|CW|CX|CY|CZ|DE|DJ|DK|DM|DO|DZ|EC|EE|EG|EH|ER|ES|ET|FI|FJ|FK|FM|FO|FR|GA|GB|GD|GE|GF|GG|GH|GI|GL|GM|GN|GP|GQ|GR|GS|GT|GU|GW|GY|HK|HM|HN|HR|HT|HU|ID|IE|IL|IM|IN|IO|IQ|IR|IS|IT|JE|JM|JO|JP|KE|KG|KH|KI|KM|KN|KP|KR|KW|KY|KZ|LA|LB|LC|LI|LK|LR|LS|LT|LU|LV|LY|MA|MC|MD|ME|MF|MG|MH|MK|ML|MM|MN|MO|MP|MQ|MR|MS|MT|MU|MV|MW|MX|MY|MZ|NA|NC|NE|NF|NG|NI|NL|NO|NP|NR|NU|NZ|OM|PA|PE|PF|PG|PH|PK|PL|PM|PN|PR|PS|PT|PW|PY|QA|RE|RO|RS|RU|RW|SA|SB|SC|SD|SE|SG|SH|SI|SJ|SK|SL|SM|SN|SO|SR|SS|ST|SV|SX|SY|SZ|TC|TD|TF|TG|TH|TJ|TK|TL|TM|TN|TO|TR|TT|TV|TW|TZ|UA|UG|UM|US|UY|UZ|VA|VC|VE|VG|VI|VN|VU|WF|WS|YE|YT|ZA|ZM|ZW)[A-Z0-9]{2}(?:[A-Z0-9]{3})?$/;
        
        
        if (!bicRegex.test(bic)) {
            return false;
        }
    }
    return true;
};

export const useValidators = () => {
    return { validateEmail, validateUrl, validateLinkedinUrl, validatePhone, validateIban, validateBic };
};
